import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
// @material-ui/core components
import {
  Grid,
  FormControl,
  MenuItem,
  Select,
  InputLabel,
} from "@material-ui/core";
// @material-ui/styles
import { makeStyles } from "@material-ui/core/styles";
import tableStyles from "../../../assets/jss/components/tableStyle";
import styles from "../../../assets/jss/layouts/appStyle";
// core components
import { LOCALE } from "../../../properties/Locale";
import { changePageTitle } from "../../../common/actions/CommonActions";
import Card from "../../../common/components/Card/Card.js";
import CardHeader from "../../../common/components/Card/CardHeader.js";
import CardBody from "../../../common/components/Card/CardBody.js";
import TrainingConfigComponent from "./training/TrainingConfigComponent";
import EducationalActivityConfigComponent from "./educationalActivity/EducationalActivityConfigComponent";
import AuthorshipConfigComponent from "./authorship/AuthorshipConfigComponent";
import ProfessionalEventConfigComponent from "./professionalEvent/ProfessionalEventConfigComponent";
import AwardsAndRecognitionConfigComponent from "./awardsAndRecognition/AwardsAndRecognitionConfigComponent";
import ProfessionalTitleConfigComponent from "./professionalTitle/ProfessionalTitleConfigComponent";

const useStyles = makeStyles(styles, tableStyles);

export default function VacancyConfigComponent(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [area, setArea] = useState(null);

  useEffect(() => {
    dispatch(changePageTitle(LOCALE.configuration_area));
  }, []);

  return (
    <div>
      <Card>
        <CardBody>
          <Grid item md={4}>
            <FormControl
              variant="outlined"
              fullWidth
              margin="normal"
              size="small"
            >
              <InputLabel>Област</InputLabel>
              <Select
                label="Област"
                defaultValue=""
                onChange={(e) => setArea(e.target.value)}
              >
                <MenuItem value="">None</MenuItem>
                <MenuItem value="TRAINING">{LOCALE.training}</MenuItem>
                <MenuItem value="PROFESSIONAL_EVENT">
                  {LOCALE.professional_event}
                </MenuItem>
                <MenuItem value="EDUCATIONAL_ACTIVITY">
                  {LOCALE.educational_activity}
                </MenuItem>
                <MenuItem value="AWARDS_AND_RECOGNITION">
                  {LOCALE.awards_and_recognition}
                </MenuItem>
                <MenuItem value="PROFESSIONAL_TITLE">
                  {LOCALE.professional_title}
                </MenuItem>
                <MenuItem value="AUTHORSHIP">{LOCALE.authorship}</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          {area === "TRAINING" && (
            <TrainingConfigComponent gradingSchemaId={props.gradingSchemaId} />
          )}

          {area === "PROFESSIONAL_EVENT" && (
            <ProfessionalEventConfigComponent
              gradingSchemaId={props.gradingSchemaId}
            />
          )}
          {area === "EDUCATIONAL_ACTIVITY" && (
            <EducationalActivityConfigComponent
              gradingSchemaId={props.gradingSchemaId}
            />
          )}
          {area === "AWARDS_AND_RECOGNITION" && (
            <AwardsAndRecognitionConfigComponent
              gradingSchemaId={props.gradingSchemaId}
            />
          )}
          {area === "PROFESSIONAL_TITLE" && (
            <ProfessionalTitleConfigComponent
              gradingSchemaId={props.gradingSchemaId}
            />
          )}
          {area === "AUTHORSHIP" && (
            <AuthorshipConfigComponent
              gradingSchemaId={props.gradingSchemaId}
            />
          )}
        </CardBody>
      </Card>
    </div>
  );
}
